<template>
  <div class="page">
    <div class="card">
      <h1>Impressum</h1>

      <div class="grid">
        <section class="box">
          <h2>Angaben gemäß geltendem Recht</h2>
          <div class="kv">
            <div class="k">Name</div><div class="v">Jean-Marie Hardt</div>
            <div class="k">Adresse</div><div class="v">Rue de Hoscheid<br>9380 Merscheid<br>Luxemburg</div>
          </div>
        </section>

        <section class="box">
          <h2>Kontakt</h2>
          <div class="kv">
            <div class="k">Telefon</div><div class="v"><a href="tel:+352691624657">+352 691 624 657</a></div>
            <div class="k">E-Mail</div><div class="v"><a href="mailto:hardt.jim@gmail.com">hardt.jim@gmail.com</a></div>
          </div>
        </section>
      </div>

      <p v-if="hasIds || hasRegister" class="note">
        <span v-if="hasIds">USt-IdNr.: …</span>
        <span v-if="hasRegister">Handelsregister: …</span>
      </p>

      <p class="note">
        Inhalte dieser Website wurden mit Sorgfalt erstellt. Für Richtigkeit, Vollständigkeit und Aktualität kann jedoch keine Gewähr übernommen werden.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({ hasIds: false, hasRegister: false })
}
</script>

<style scoped>
.page{max-width:1000px;margin:40px auto;padding:0 16px;color:#fff}
.card{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08);border-radius:14px;padding:18px}
h1{margin:0 0 14px;font-size:28px}
.grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}
.box{background:rgba(0,0,0,.35);border:1px solid rgba(255,255,255,.08);border-radius:14px;padding:14px}
h2{margin:0 0 10px;font-size:16px;opacity:.9}
.kv{display:grid;grid-template-columns:120px 1fr;gap:8px 12px;align-items:start}
.k{opacity:.7}
.v{line-height:1.6}
a{color:#00aeff;text-decoration:none}
a:hover{opacity:.9}
.note{opacity:.75;margin-top:14px;line-height:1.6}
@media (max-width:900px){
  .grid{grid-template-columns:1fr}
  .kv{grid-template-columns:100px 1fr}
}
</style>